import React from 'react';

const PostTwo = React.forwardRef(({ post }: any, ref) => {
	const postBody = (
		<div className="bg-gray-500 mb-5 px-3 rounded-md py-3">
			<h2>{post.title}</h2>
			<p>{post.body}</p>
			<p>Post ID: {post.id}</p>
		</div>
	);

	const content = ref ? (
		// @ts-ignore
		<article ref={ref}>{postBody}</article>
	) : (
		<article>{postBody}</article>
	);

	return content;
});

export default PostTwo;
